import { MacScrollbar } from 'mac-scrollbar';
import React, { useEffect, useState } from 'react';
import { isMobile } from 'react-device-detect';
import styled from 'styled-components';

interface ModalBaseProps {
    onClose: () => void;
    children: React.ReactNode;
    width?: string;
    height?: string;
    hideXButton?: boolean;
}

const Scrollbar = styled(MacScrollbar)`
    flex: 1; /* Take up remaining space */
    overflow-y: auto; /* Enable scrolling */
    width: 100%;
    // display: flex;
    // flex-direction: column;
`;

const ModalBase: React.FC<ModalBaseProps> = ({
    onClose,
    children,
    width = '400px',
    height,
    hideXButton = false,
}) => {
    const [isModalVisible, setIsModalVisible] = useState(false);

    // Prevent body scrolling when modal is open & handle open animation
    useEffect(() => {
        const originalOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';

        // Trigger open animation
        const timer = setTimeout(() => {
            setIsModalVisible(true);
        }, 50); // Small delay to ensure transition occurs

        return () => {
            document.body.style.overflow = originalOverflow;
            clearTimeout(timer);
        };
    }, []);

    const handleClose = () => {
        setIsModalVisible(false); // Trigger close animation
        setTimeout(() => {
            onClose(); // Call original onClose after animation
        }, 300); // Match CSS transition duration
    };

    const handleContainerClick = (e: React.MouseEvent<HTMLDivElement>) => {
        e.stopPropagation(); // Prevent click event from propagating to modal-background
    };

    return (
        <div
            className={`modal-background ${isModalVisible ? 'open' : ''}`}
            onClick={handleClose}
        >
            <div
                className={`modal-container ${isMobile && 'mobile'} ${
                    isModalVisible ? 'open' : ''
                }`}
                style={{ width, height }}
                onClick={handleContainerClick}
            >
                {!hideXButton && (
                    <div
                        className="modal-close-button"
                        onClick={handleClose}
                    ></div>
                )}
                <Scrollbar
                    trackStyle={(horizontal) => ({
                        [horizontal ? 'height' : 'width']: 0,
                        right: 0,
                        border: 0,
                    })}
                    thumbStyle={(horizontal) => ({
                        [horizontal ? 'height' : 'width']: 6,
                    })}
                >
                    {children}
                </Scrollbar>
            </div>
        </div>
    );
};

export default ModalBase;
